export default __webpack_public_path__ + "static/media/dashboard-active.860196e1.svg";